/**
 * Google Analytics 4 helper + custom event wrappers.
 * The GA4 Measurement ID is embedded in index.html.
 */

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
  }
}

export function trackEvent(name: string, params?: Record<string, string | number | boolean>) {
  try {
    window.gtag?.("event", name, params);
  } catch {}
}

export function trackPageView(path: string, title?: string) {
  trackEvent("page_view", { page_path: path, page_title: title ?? document.title });
}

// ── Custom events ──

export function trackBookingSubmitted(service: string) {
  trackEvent("booking_submitted", { service });
}

export function trackChatOpened() {
  trackEvent("chat_opened");
}

export function trackChatMessageSent() {
  trackEvent("chat_message_sent");
}

export function trackContentClick(contentType: string, slug: string) {
  trackEvent("content_click", { content_type: contentType, content_slug: slug });
}

export function trackCtaClicked(label: string) {
  trackEvent("cta_clicked", { cta_label: label });
}
